import React from 'react';
import { Field, FieldArray, reduxForm, initialize } from 'redux-form'
import Divider from 'material-ui/Divider';
import Paper from 'material-ui/Paper';

import moment from 'moment'

import DoneIcon from 'material-ui/svg-icons/action/done';
import PersonIcon from 'material-ui/svg-icons/social/person';
import ForwardIcon from 'material-ui/svg-icons/content/forward';
import ReplyIcon from 'material-ui/svg-icons/content/reply';
import MenuItem from 'material-ui/MenuItem';

import FlatButton from 'material-ui/FlatButton';
import * as colors from 'material-ui/styles/colors';

import FormSelect from '../../../components/FormSelect'
import FormLabel from '../../../components/FormLabel'
import FormAutoComplete2 from '../../../components/FormAutoComplete2'
import FormDatePicker from '../../../components/FormDatePicker'
import FormText from '../../../components/FormText'
import FormSubHolidayContents from '../../../components/FormSubHolidayContents'
import * as commons from '../../../commons';
import * as actions from '../../../actions';
import styles from '../../../styles'



const style = {
  paper: {
    padding: 20,
    margin: 20,
  }
}

const validateMonth = (month) => {

  if (!month || !month.length) {
    return []
  }

  let tmpList = []
  const monthErrors = []
  month.forEach((ele, index) => {
    const error = {}
    if (!ele.kind) {
      error.kind = '必須入力'
    }
    if (!ele.date) {
      error.date = '必須入力'
    } else {
      const date = moment(new Date(ele.date)).format('YYYY/MM/DD')

      if (tmpList.indexOf(date) >= 0) {
        error.date = '日付が重複しています'
      } else {
        tmpList.push(date)
      }
    }
    
    monthErrors[index] = error
  })

  return monthErrors

}

const validate = values => {
  const errors = {}

  for (let i = 0; i < 12; i++) {
    let monthErrors = validateMonth(values["month" + (i + 1)])
    if (monthErrors.length) {
      errors["month" + (i + 1)] = monthErrors
    }
  }

  return errors
}

class SubHolidayMasterForm extends React.PureComponent {
  
  constructor(props) {
    super(props)
  }

  goBack(userId, backDate) {
    this.props.history.push(`/roumu/${userId}/${backDate}`)
  }

  render() {

    const { 
      auth,
      otherUserEdit,
      backDate,
      userId,
      initialValues,
      onRemoveDate,
      onRegist,
      onChangeYear,
      handleSubmit,
      error
    } = this.props

    const year = initialValues.year || (new Date()).getFullYear()

    return (

      <form onSubmit={() => {}}>

        {error && <div><span style={{ color: 'rgb(244, 67, 54)' }}>{error}</span></div>}

        <div className="row" key={1}>
          <div className="col">

            <Paper style={style.paper}>
              <div className="row">
                <div className="col-4">
                  <h4 style={styles.yosanFormTitle}>休日出勤日</h4>
                </div>
                <div className="col-4">
                  <h4 style={styles.yosanFormTitle}>代休使用日</h4>
                </div>
              </div>

              <Divider style={{ marginBottom: 10 }} />

              {/*{!initialValues.subHolidayContents && <div style={{marginTop:30, color: colors.grey700}}>休出データが存在しません。</div>}*/}

              <FieldArray
                  auth={auth}
                name={"subHolidayContents"}
                component={FormSubHolidayContents}
                onRemoveDate={onRemoveDate}
              />

            </Paper>
          </div>
        </div>

        <div style={styles.buttons}>

          {backDate &&
            (
              <FlatButton
                label="労務登録へ戻る"
                primary={true}
                style={{marginRight: 20}}
                onTouchTap={() => {
                  this.goBack(userId, backDate)
                }}
              />

            )
          }

            {/*{*/}
                {/*!otherUserEdit &&*/}
                {/*(*/}
                {/*<FlatButton*/}
                    {/*label="登録"*/}
                    {/*labelPosition="before"*/}
                    {/*primary={true}*/}
                    {/*labelStyle={{ color: colors.white, lineHeight: '40px' }}*/}
                    {/*style={{ height: '40px', width: '100px' }}*/}
                    {/*backgroundColor={colors.cyan700}*/}
                    {/*hoverColor={colors.cyan900}*/}
                    {/*icon={<DoneIcon color={colors.white} />}*/}
                    {/*onClick={handleSubmit(onRegist)}*/}
                {/*/>*/}
                {/*)*/}
            {/*}*/}

            {
                ((otherUserEdit && auth.user.permission == 2) || auth.user.id == userId) &&
                (
                    <FlatButton
                        label="登録"
                        labelPosition="before"
                        primary={true}
                        labelStyle={{ color: colors.white, lineHeight: '40px' }}
                        style={{ height: '40px', width: '100px' }}
                        backgroundColor={colors.cyan700}
                        hoverColor={colors.cyan900}
                        icon={<DoneIcon color={colors.white} />}
                        onClick={handleSubmit(onRegist)}
                    />
                )
            }

        </div>

      </form>
    );
  }
};

SubHolidayMasterForm = reduxForm({
  form: 'subHolidayMasterForm',
  enableReinitialize: true,
  validate,
  onSubmitFail: (errors, dispatch) => {
    dispatch(actions.reducerSnackBar(true, '入力内容に誤りがあります。', colors.red400))
  },
})(SubHolidayMasterForm)

export default SubHolidayMasterForm


// WEBPACK FOOTER //
// ./src/containers/master/subHoliday/SubHolidayMasterForm.js